import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Button } from 'components/shared/Button/Button'
import { Form } from 'components/shared/Form/Form'
import { CategoryFieldsGroup } from './common/CategoryFieldsGroup/CategoryFieldsGroup'
import { QuestionFieldsGroup } from './common/QuestionFieldsGroup/QuestionFieldsGroup'

import { useContext } from 'hooks'
import {
  InterviewsCreatorHandlersContext,
  InterviewsCreatorStateContext,
} from 'components/modules/creators/TemplatesCreator/tabs/Interviews/context'

import styles from './CategoryEdit.module.scss'

export const CategoryEdit = () => {
  const state = useContext(InterviewsCreatorStateContext)
  const handlers = useContext(InterviewsCreatorHandlersContext)

  const {
    edit,
    hasNoQuestions,
    isCategoryScorable,
    isCategoryDeletable,
    isStaticPage,
  } = state
  const {
    handleDeleteCategoryOpen,
    handleDeleteQuestionOpen,
    handleEditCategoryCancel,
    handleEditCategoryConfirm,
    handleInsertQuestion,
  } = handlers

  const { control, fields, formState, watch } = edit

  return (
    <Box className={styles.edit} direction="column" justify="flex-start">
      <Form className={styles.form}>
        <CategoryFieldsGroup
          onDeleteCategoryOpen={handleDeleteCategoryOpen}
          {...{
            control,
            formState,
            watch,
            isCategoryScorable,
            isCategoryDeletable,
            isStaticPage,
          }}
        />
        <QuestionFieldsGroup
          onDeleteQuestionOpen={handleDeleteQuestionOpen}
          onInsertQuestion={handleInsertQuestion}
          {...{
            control,
            fields,
            formState,
            hasNoQuestions,
          }}
        />
      </Form>
      <Box align="center" className={styles.footer} justify="flex-end">
        <Button
          className={styles.button}
          label={t`Cancel`}
          size="medium"
          variant="outlined"
          onClick={handleEditCategoryCancel}
        />
        <Button
          className={styles.button}
          color="primary"
          label={t`Save`}
          size="medium"
          variant="filled"
          onClick={handleEditCategoryConfirm}
          isDisabled={R.not(formState.isDirty)}
        />
      </Box>
    </Box>
  )
}
